import { useContext, useState } from 'react';
import * as R from 'ramda';

import versionIcon from '@atom/components/common/svgIcons/versionIcon.svg';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton, Modal, Snackbar } from '@atom/mui';
import api from '@atom/utilities/api';
import { WORK_ORDERS_ENDPOINT } from '@atom/utilities/endpoints';

import WorkOrderContext from '../WorkOrderContext';

import classes from './workOrderDetailHeader.module.css';

const WorkOrderVersionButton = () => {
  const [, { navigate }] = useNavigation();
  const { workOrderDetail } = useContext(WorkOrderContext);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const applyHistorySnapshot = async () => {
    const { id, inventoryAssetName, inventoryAssetId, formInstances } =
      workOrderDetail;
    setLoading(true);

    const endpoint = `${WORK_ORDERS_ENDPOINT}/${id}/apply`;

    const formInstanceIds = R.keys(formInstances);
    const body = {
      inventoryAssetName,
      rootAssetId: inventoryAssetId,
      ...(!R.isEmpty(formInstanceIds) && { formInstanceIds }),
    };

    try {
      await api.post(endpoint, body);

      Snackbar.info({
        message: `Asset ${inventoryAssetName} updated.`,
        action: 'View',
        onActionClick: () => navigate(`/inventory/${inventoryAssetId}`),
      });
    } catch (error) {
      Snackbar.error({
        message: 'Could not version asset',
      });
    }

    setLoading(false);
    setOpen(false);
  };

  return (
    <>
      <IconButton
        tooltip="Version Asset"
        edge="end"
        onClick={() => setOpen(true)}
      >
        <Icon>
          <img src={versionIcon} />
        </Icon>
      </IconButton>
      <Modal
        title={`Update asset ${workOrderDetail.inventoryAssetName}?`}
        open={open}
        onCancel={() => setOpen(false)}
        onConfirm={applyHistorySnapshot}
        confirmButtonText="Update"
        loading={loading}
      >
        <div className={classes.applyHistoryModalContent}>
          <div>
            This will update asset
            <span className={classes.strong}>
              {workOrderDetail.inventoryAssetName}
            </span>
            with work{' '}
            <span className={classes.strong}>{workOrderDetail.name}</span>
            data. Documents, photos and videos in this work will transfer to
            asset
            <span className={classes.strong}>
              {workOrderDetail.inventoryAssetName}.
            </span>
          </div>
          <div className={classes.modalSubtext}>
            Please note that versioning will update the asset regardless of
            attribute settings that make values required or uneditable.
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WorkOrderVersionButton;
